// 引入windi css
import '@/plugins/unocss'

// 导入全局的svg图标
import '@/plugins/svgIcon'

// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n'

// 引入状态管理
import { setupStore } from '@/store'

// 全局组件
import { setupGlobCom } from '@/components'

// 引入全局样式
import '@/styles/index.less'
// 引入tailwindcss
import '@/index.css'

// 引入动画
import '@/plugins/animate.css'

// 引入element-plus
import { setupElementPlus } from '@/plugins/elementPlus'

import { setVueResponsiveness } from '@/plugins/vueResponsiveness'

// 路由
import { setupRouter } from './router'



// Vue 事件总线插件
import EventBus from 'vue3-eventbus';

import { createApp } from 'vue'

import App from './App.vue'

import './permission'

// 权限
import { setupPermission } from './directives'
// 引入arms
import '@/baseConfig/arms.js'

// 创建实例
const setupAll = async () => {
  const app = createApp(App)

  await setupI18n(app)

  setupStore(app)

  setupGlobCom(app)

  setupElementPlus(app)

  setVueResponsiveness(app)

  setupRouter(app)

  setupPermission(app)

  app.mount('#app')

  app.use(EventBus)
}

setupAll()
